import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Link from 'components/common/Link/Link'
import Media from 'components/common/Media'

const BOTBrandMarketingSpotligh = ({ logoURL, videoURL, description }) =>
  <CustomLink to={ videoURL }>
    <Image src={ logoURL } alt={ description } />
  </CustomLink>

BOTBrandMarketingSpotligh.type = 'BOTBrandMarketingSpotligh'

export default BOTBrandMarketingSpotligh

BOTBrandMarketingSpotligh.propTypes = {
  description: PropTypes.string,
  logoURL: PropTypes.string,
  videoURL: PropTypes.string
}

const CustomLink = styled(Link)`
  display: inline-block;
`

const Image = styled.img`
  max-width: 324px;
  ${Media.mobile`
    width: 100%;
    max-width: 288px;
  `}
`
